//  Link media
require.context('../media/', true, /^\.\/.*\.*/);
//  Styles
import '../styles/styles.scss';
// JS
import $ from 'jquery';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { TextPlugin } from "gsap/TextPlugin";
import { ScrollSmoother } from "gsap/ScrollSmoother";
// import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";

gsap.registerPlugin(ScrollTrigger, SplitText); 


let Site;
var breakpointSite = 768;

const touch = matchMedia('(hover: none)').matches;

const greetings = {
  wl: ["Woojin !", "Woojin Lee", "Wishing you a year filled with joy, to move in your new home soon and be happy, and enjoy plenty of extraordinary moments."],
  mo: ["Mark !", "Mark O", "Wishing you a year filled with joy for you and your loved ones, and a great trip back to NZ soon."],
  tk: ["Tayo !", "Tayo K.", "Wishing you a year filled with joy for you and your loved ones. Stay inspired and continue thriving on your creative journey!"],
  ak: ["Adnan !", "Adnan K", "Wishing you a year filled with joy for you and your loved ones, keep your creative path!"],
	nk: ["Natalie !", "Natalie K.", "Wishing you a year filled with joy for you and your loved ones. Stay inspired and continue thriving on your creative journey!"],
  ng: ["Nellie !", "Nellie G.", "Wishing you a year filled with joy for you and your loved ones. May your walks with your dog bring you clarity and peace, and may you do more writing and work you love."],
  jq: ["Jo !", "Jo Quaye", "Wishing you a year filled with joy for you and your loved ones. Keep your team inspired and continue spreading your positive energy!"],
  gn: ["Genia !", "Genia N.", "Wishing you a year filled with joy for you and your loved ones. Keep your good energy, and thanks for all the millions of copy edits you did last year!"],
  lv: ["Lois !", "Lois V.", "Wishing you a year filled with joy for you and your loved ones. Keep your good energy and thanks for all the millions of copy edits you did last year!"],
  ms: ["Samuel !", "Samuel S.", "Wishing you a year filled with joy for you and your loved ones. Keep pushing the team for good work and may orphan words not exist in 2025 haha!"],
  sg: ["Sarah-Grace !", "SG L.", "Wishing you a year filled with joy for you and your loved ones, along with extraordinary moments on your young mum’s journey! Keep your creativity flowing, stay refreshed, and continue spreading positivity around you!"],
  cc: ["Connor !", "Connor C.", "Wishing you a year filled with joy, creativity, and inspiration. Stay refreshed and keep thriving on all your design journey."],
  vc: ["Vanessa !", "Vanessa C.", "Wishing you a year filled with joy for you and your loved ones. Keep your team inspired and continue spreading positive energy!"],
  wk: ["Weronika !", "Weronika W.", "Wishing you a year filled with joy for you and your loved ones. Keep the team inspired and continue spreading positive energy!"],
  ap: ["Alex !", "Alex P.", "Je te souhaite une année remplie de joie pour toi et tes proches, ainsi que des moments extraordinaires dans ton voyage de papa pour la deuxième fois !!"],
  ew: ["Ellis !", "Ellis W.", "Wishing you a year filled with joy, inspiration, and extraordinary moments. Keep shining with your amazing organizational skills and the power of words!"],
  fm: ["Matthew !", "Matthew Ford", "Wishing you a year filled with joy for you and your loved ones. Keep your team inspired and growing, spreading positive energy!"],
  ob: ["Ollie !", "Ollie Burch", "Wishing you a year filled with joy, inspiration, and extraordinary moments. Keep your team inspired and continue spreading positive energy!"],
  nr: ["Noemi !", "Noemi R.", "Wishing you a year filled with joy and extraordinary moments. Keep your team inspired and continue spreading positive energy!"],
  jb: ["Jed !", "Jed Backhouse", "Wishing you a year filled with joy and extraordinary moments. Keep your team inspired and continue spreading positive energy in what you do!"],
  mb: ["Maxine !", "Maxine Budd", "Wishing you a year filled with joy for you and your loved ones. Stay inspired and keep moving forward on your creative journey!"],
  cs: ["Camille !", "Camille Sim", "Wishing you a year filled with joy for you and your loved ones. Keep your team inspired and continue spreading positive energy!"],
  rsm: ["Rob !", "Rob Smith", "Wishing you a year filled with joy and extraordinary moments. Stay inspired and continue thriving on your creative journey!"],
  fd: ["Faberge !", "Faberge David", "Wishing you a year filled with joy for you and your loved ones. Keep teams boosted and continue spreading positive energy!"],
  fj: ["Frances !", "Frances J.", "Wishing you a year filled with joy, inspiration, and extraordinary moments. Keep shining with your amazing organizational skills and spreading good energy!"],
  jk: ["James !", "James Kape", "Wishing you a year filled with joy for you and your loved ones. Keep your team inspired and continue spreading positive energy!"],
  ec: ["Élann !", "Élann Carel-Maloney", "Wishing you a year filled with joy, inspiration, and extraordinary moments. Keep shining with your amazing organizational skills and spreading good energy!"],
  smg: ["Stephen !", "Stephen McGilvray", "Wishing you a year filled with joy, inspiration, and extraordinary moments. Keep your team inspired and continue spreading positive energy!"],
  cc2: ["Chris !", "Chris Copping", "Wishing you a year filled with joy, inspiration, and extraordinary moments. Keep your team inspired and continue spreading positive energy!"],
  aj: ["Alastair !", "Alastair Jones", "Wishing you a year filled with joy for you and your loved ones. Stay inspired and continue thriving on your creative journey!"],
  ks: ["Krystina !", "Krystina Shveda", "Wishing you a year filled with joy, inspiration, and extraordinary moments. And always more travels. Keep dataset sharp as always, haha!"],
  nc: ["Natalie !", "Natalie Coker", "Wishing you a year filled with joy for you and your loved ones. Keep your creativity flowing, stay refreshed, and your design sharp!"],
  as: ["Ally !", "Ally Sinyard", "Wishing you a year filled with joy, inspiration, and extraordinary moments. Stay refreshed and healthy with your sporty routine, and share the positive energy around you!"],
  mab: ["Marianne !", "Marianne Ashton-Booth", "Wishing you a year filled with joy for you and your loved ones. Keep your creativity flowing, wishing you to do more talks, stay refreshed, and your design sharp!"],
  mbr: ["Matt !", "Matt Brown", "Wishing you a year filled with joy, inspiration, and extraordinary moments. Keep your team inspired and continue spreading positive energy!"],
  ca: ["Chris !", "Chris Abdullahi", "Wishing you a year filled with joy, inspiration, and extraordinary moments. Keep your team inspired and continue spreading positive energy!"],
  pr: ["Peter !", "Peter Robertson", "Wishing you a year filled with joy for you and your loved ones. Keep your creativity flowing, stay refreshed, and your design sharp!"],
  st: ["Sarah !", "Sarah Tilotta", "Wishing you a year filled with joy for you and your loved ones. Keep your creativity flowing, wishing lots of interesting work at Adobe!"],
  db: ["David !", "David Blood", "Wishing you a year filled with joy for you and your loved ones. Keep your creativity flowing, stay refreshed, and your design sharp! All the best in your new role."],
  ps: ["Paul !", "Paul Sims", "Wishing you a year filled with joy and extraordinary moments. Keep your team inspired and continue spreading positive energy!"],
  sr: ["Rachel !", "Rachel Silk", "Wishing you a year filled with joy, inspiration, and extraordinary moments. Keep shining with your amazing organizational skills and spreading good energy!"],
  jbr: ["Jonathan !", "Jonathan Bradford", "Wishing you a year filled with joy, inspiration, and extraordinary moments. Keep your team inspired and continue spreading positive energy!"],
  mp: ["Matthew !", "Matthew Percival", "Wishing you a year filled with joy for you and your loved ones. Keep your team inspired and continue spreading positive energy!"],
  ccl: ["Caitlin !", "Caitlin Clancy", "Wishing you a year filled with joy for you and your loved ones. Hope you get to embrace more art direction projects and keep up the creative work!"],
  vm: ["Vlad !", "Vlad Molico", "Wishing you a year filled with joy for you and your loved ones. Stay inspired and continue thriving on your creative journey!"],
  alm: ["Anna-Line !", "Anna-Line Massot", "Je te souhaite une année remplie de joie pour toi et tes proches. Reste inspiré et continue à t’épanouir dans ton parcours !"],
  rp: ["Rob !", "Rob Pilkinton", "Wishing you a year filled with joy for you and your loved ones. Stay inspired and continue thriving on your creative journey!"],
  jw: ["Jenny !", "Jenny Wong", "Wishing you a year filled with joy for you and your loved ones. Keep your team inspired and continue spreading positive energy!"],
  ot: ["Oliver !", "Oliver Thein", "Wishing you a year filled with joy for you and your loved ones. Keep your team inspired and continue spreading positive energy!"],
  ss: ["Simone !", "Simone Strahle", "Wishing you a year filled with joy for you and your loved ones. Keep your team inspired and continue spreading positive energy!"],
  bl: ["Ben !", "Ben Leonard", "Wishing you a year filled with joy for you and your loved ones. Stay inspired and continue thriving on your creative journey!"],
  mm: ["Matthieu !", "Matthieu M", "Je te souhaite une année remplie de joie pour toi et tes proches, ainsi que des moments extraordinaires dans ton voyage de papa!"],
  cb: ["Chris !", "Chris Barker", "Wishing you a year filled with joy for you and your loved ones. Stay inspired and continue thriving on your creative journey!"],
  npc: ["Nick !", "Nick Payne Cook", "Wishing you a year filled with joy for you and your loved ones. Keep your team inspired and continue spreading positive energy (and silly jokes)!"],
  jgo: ["Jonny !", "Jonny Goodall", "Wishing you a year filled with joy for you and your loved ones. Stay inspired and continue spreading positive energy among creatives!"],
  sm: ["Sabrina !", "Sabrina Maerky", "Wishing you a year filled with joy, inspiration, and extraordinary moments. Keep your team inspired and continue spreading positive energy."],
  cm: ["Camilla !", "Camilla Petty", "Wishing you a year filled with joy, inspiration, and extraordinary moments. Keep shining with your amazing organizational skills and the power of words!"],
  mf: ["Madeleine !", "Madeleine Fortescue", "Wishing you a year filled with joy, inspiration, and extraordinary moments. Keep your team inspired and continue spreading positive energy."],
  sa: ["Sophie !", "Sophie Aspden", "Wishing you a year filled with joy, inspiration, and extraordinary moments. Keep your team inspired and continue spreading positive energy."],
  rs: ["Roberto !", "Roberto Sobachi", "Wishing you a year filled with joy, inspiration, and extraordinary moments. Keep your team inspired and continue spreading positive energy."],
  wc: ["Wayne !", "Wayne Crosby", "Wishing you a year filled with joy, inspiration, and extraordinary moments. Keep your team inspired and continue spreading positive energy."],
  ag: ["Anthony !", "Anthony Galvin", "Wishing you a year filled with joy, inspiration, and extraordinary moments. Keep your team inspired and continue spreading positive energy."],
  am: ["Adeline !", "Adeline Moreau", "Wishing you a year filled with joy for you and your loved ones. Stay inspired and continue thriving on your creative journey!"],
  jg: ["Jarret !", "Jarret Gabel", "Wishing you a year filled with joy, inspiration, and extraordinary moments. Keep your team inspired and spread positive energy."]
};

(function ($) {
	'use strict';

	Site = {
		/**
		 * initialize prototype
		 *
		 */
		init: function (elt) {
			var self = this;

			// self.scrollToAnchor();
			self.newWindowLink();


			// Get the hash from the URL
			const hash = window.location.hash.substring(1); // Get the part after '#', like 'wl', 'mo', etc.

			// Check if the hash matches one of the keys in the greetings object
			if (greetings[hash]) {
			  // Replace the content of the .js-name and .js-greeting elements with the corresponding greeting
			  const [name, fullname, greeting] = greetings[hash]; // Destructure the array into 'name' and 'greeting'
			  // Replace the name and greeting in the HTML
			  $('.js-name').text(name);
			  $('.js-greeting').text(greeting);
			}
						
			// const touch = matchMedia('(hover: none)').matches;
			// if(document.referrer == "") {
			// 	if(touch) {
			// 		// $('.cp-bg-layer, .flex-v-center:not(.h-auto) ').css('height', $(window).outerHeight());
			// 	}
			// }
			// if(touch) {
			// 	window.addEventListener('resize', () => {
			// 		// We execute the same script as before
			// 		// $('.cp-bg-layer, .flex-v-center:not(.h-auto) ').css('height', $(window).outerHeight());
			// 	});
			// }

			// Detect Safari using JavaScript
			if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
			  $('body').addClass('is-safari');
			}

			// self.removeOrphans();
			self.loazyloadImage('.wrapper-article');
		

			document.fonts.ready.then(function () {
				self.scrollAnimation();
				self.inviewAnimation();
				// self.countUpNumbers();
				// self.scrollRefresh();
				// self.showRelevantCTA();
				// self.scrollIndicator();
			});
			// const scroll = new LocomotiveScroll();
		},	

		removeOrphans: function(){
			// remove orphans / widows 
			$('.js-greeting, .wnw').each(function() {
				const text = $(this).html();
				const words = text.split(' ');
				const totalWords = words.length;

				if(!$(this).parents().hasClass('dont-apply-words-nowrap')) {

					// Ensure there are at least 2 words
					if (totalWords >= 2) {
						const formattedLastWords = `<span class="words-nowrap">${words[totalWords - 2]} ${words[totalWords - 1]}</span>`;
						const newText = text.substring(0, text.length - (words[totalWords - 2].length + words[totalWords - 1].length + 1)) + formattedLastWords;
						$(this).html(newText);
					}
				}
			});
		},


		// scrollIndicator: function() {
		// 	const IDLE_TIMEOUT = 7000; // Milliseconds (change this to 5000 for 5 seconds)
		// 	let idleTimer;

		// 	var $indicator = $('.fixed-scroll-indicator');

		// 	function resetIdleTimer() {
		// 		$indicator.attr('data-visible','0');
		// 	  	clearTimeout(idleTimer);
		// 	  	idleTimer = setTimeout(handleInactivity, IDLE_TIMEOUT);
		// 	}

		// 	function handleInactivity() {
		// 	  	// User has been inactive for 5 seconds
		// 	  	$indicator.attr('data-visible','1');
		// 	}

		// 	function stopInactivityDetection() {
		// 	  	clearTimeout(idleTimer);
		// 	  	// You can optionally remove event listeners here if needed
		// 	}

		// 	// Attach event listeners to capture user interactions
		// 	window.addEventListener('mousemove', resetIdleTimer);
		// 	window.addEventListener('mousedown', resetIdleTimer);
		// 	window.addEventListener('touchstart', resetIdleTimer);
		// 	window.addEventListener('keydown', resetIdleTimer);
		// 	window.addEventListener('scroll', resetIdleTimer);

		// 	// Add event listener for user leaving the page (beforeunload)
		// 	window.addEventListener('beforeunload', stopInactivityDetection);

		// 	// Call resetIdleTimer on page load to start the timer
		// 	resetIdleTimer();


		// 	ScrollTrigger.create({
		// 		trigger: '.client-footer', 
		// 		scrub: true,
		// 		start: "top bottom",
		// 		onEnter: function(){
		// 			$indicator.find('i').hide();
		// 		},
		// 		onLeaveBack: function(){
		// 			$indicator.find('i').show();
		// 		},
		// 	});

		// },
		debounce: function (func, wait, immediate) {
			var timeout;
			return function() {
				var context = this, args = arguments;
				var later = function() {
					timeout = null;
					if (!immediate) func.apply(context, args);
				};
				var callNow = immediate && !timeout;
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
				if (callNow) func.apply(context, args);
			};
		},

		scrollAnimation: function (section) {
			var self = this;
			
			// ScrollTrigger.create({
			// 		trigger: '.hero',
			// 		scrub: true,
			// 		pin: true,
			// 		// anticipatePin: true,
			// 		start: "top 0",
			// 		end: "100%",
			// 		pinSpacing: false,
			// 	});

			const split = new SplitText('.h1 strong', { type: 'words' });
			gsap.set(split.words, {opacity: 0});
			gsap.set('.h1 strong', {opacity: 1});

			var title = gsap.timeline()
							.from('.h1 i', {width: 10, duration:1})
							.to('.h1 .line--1 .reverse', {yPercent: 100, duration:1})
							.to('.h1 .line--2 .reverse', {yPercent: -100, duration:1}, '<')
							.to('.h1 .line--1 .normal', {top: 0, duration:1}, '<')
							.to('.h1 .line--2 .normal', {top: 0, duration:1}, '<')
							// .to('.h1 ', {color: '#FBF5E9', duration:0.4}, '<')
							// .to('.h1 strong', {opacity: 1, duration:1})
							.to(
							  split.words, // We are now targeting the words array created by SplitText
							  {
							    opacity: 1,
							    stagger: 0.5, // Delay between each word animation
							    duration: 0.5, // Duration of each fade-in
							  }
							)
							// .to('.hero__inner', {height: '80vh', duration:.7})
							.add(function(){
								$('.hero__inner').addClass('reduced')
							})

			
			const creativeyear = new SplitText('.creative-year', { type: 'words' });

			const copyElement = $('.l1');
			const reversedText = $('.l2');

			$('.creative-year').each(function() {
				const $triggerElt = $(this);
				ScrollTrigger.create({
					trigger: $triggerElt,
					scrub: true,
					pin: true,
					// anticipatePin: true,
					start: "end 50%",
					end: "100%",
					// pinSpacing: false,
					animation: 
						gsap.timeline().to(creativeyear.words, {
						    color: '#26538A',   // Slightly scale up the words
						    y: -10,       // Move the words up to simulate a "jump"
						    duration: 0.3, // Duration of the jump effect
						    stagger: 0.1  // Stagger the jump effect for each word
					  	})
					  	.to(creativeyear.words, { opacity: 1, duration: .4})
					  	.to(creativeyear.words, { opacity: 0, duration: 1})
						// .to(copyElement, {
						//   duration: 1,
						//   rotationX: 90,  // Flip the element 180 degrees						
						// })

				});
			});

			


			ScrollTrigger.create({
				trigger: '.sticky-1',
				scrub: true,
				pin: true,
				// markers: true,
				anticipatePin: true,
				start: "top top",
				end: "bottom top",
				// pinSpacing: false,
				onEnter: function(){
					gsap.to($('.sticky-1').find('.txt-sticky-left'), {color: '#26538A', duration:0.3})
				},
				onLeaveBack: function(){
					gsap.to($('.sticky-1').find('.txt-sticky-left'), {color: 'transparent', duration:0.3})
				}
			});


			// ScrollTrigger.create({
			// 	trigger: '.c-container',
			// 	scrub: true,
			// 	pin: true,
			// 	markers: true,
			// 	anticipatePin: true,
			// 	start: "top top",
			// 	end: "100%",

			// });

			ScrollTrigger.create({
				trigger: '.sticky-1',
				scrub: true,
				// markers: true,
				start: "top top",
				end: "bottom top",
				// pinSpacing: false,
				animation: gsap.timeline().from(".c-container span", 0.5, {
				  opacity: 1,
				  scale: 1,
				  rotation: () => gsap.utils.random(-360, 360),
				  x: () => gsap.utils.random(-500, 500), // Random X offset
				  y: () => gsap.utils.random(100, 700), // Random Y offset
				  // ease: "bounce.out",
				  stagger: 0.05
				}),

			});
			


			const fftl = gsap.timeline({ repeat: -1});

			  fftl.to(".bd--1", {
			    duration: 1, // Duration for each font change
			    fontFamily: '"Roboto", sans-serif', // Change to first font (Roboto)
			    ease: "power2.inOut"
			  })
			  .to(".bd--1", {
			    duration: 1,
			    fontFamily: '"Open Sans", sans-serif', // Change to second font (Open Sans)
			    ease: "power2.inOut"
			  })
			  .to(".bd--1", {
			    duration: 1,
			    fontFamily: '"Montserrat", sans-serif', // Change to third font (Montserrat)
			    ease: "power2.inOut"
			  });


			var glassTL = gsap.timeline({paused:true})
						.to('.ic--1', { 
							opacity: 1,
						    scale: 1,        // First bounce (scale up)
						    duration: 0.3,     // Quick scale-up for the first bounce
						    // ease: "bounce.in", 
						  })
						.to('.broken_glass', { opacity: 0.1, duration: 0.04, })


			ScrollTrigger.create({
				trigger: '.ic-container',
				scrub: true,
				pin: true,
				// markers: true,
				// anticipatePin: true,
				start: "top top",
				end: "bottom top",
				// pinSpacing: false,
				onEnter: function(){
					glassTL.play();
				},
				onLeaveBack: function(){
					glassTL.reverse();
				},
				// animation: 
				// 	gsap.timeline()
				// 		.to('.ic--1', { 
				// 			opacity: 1,
				// 		    scale: 1,        // First bounce (scale up)
				// 		    duration: 0.3,     // Quick scale-up for the first bounce
				// 		    // ease: "bounce.in", 
				// 		  })
				// 		.to('.broken_glass', { opacity: 1, duration: 0.1, })

			});


		

		



			ScrollTrigger.create({
				trigger: '.wm-container',
				scrub: true,
				pin: true,
				// markers: true,
				// anticipatePin: true,
				start: "top top",
				end: "100%",

			});

			
			const webmagic = new SplitText('.wm--1 span', { type: 'words, chars' });

			ScrollTrigger.create({
				trigger: '.wm-container',
				scrub: true,
				// markers: true,
				// anticipatePin: true,
				start: "start 0",
				end: "100%",
				// pinSpacing: false,
				animation: 
					gsap.timeline()
					.from(webmagic.chars, {duration: 0.5, yPercent: 120, rotation: 5, ease: "power", stagger: 0.02})
					.to('.mask', { translateY: '115vh', duration: 1, })
					.to('.wm--2', { opacity: 1, backgroundColor: '#26538a', duration: 0.1, }, '-=0.1')
					.to('.wm--1', { opacity: 0, duration: 0.1, }, '<')
					.to('.wm--2 span', { opacity: 0.05, scale: 2, duration: 0.2, }, '-=50%')
					.from('.get-in-touch span', { opacity: 0, duration: 0.2, }, '-=0%')
					.from('.get-in-touch a', { opacity: 0, duration: 0.2, }, '-=0%')
					// .to('.mask', { translateY: '0%', duration: 1, })
					// .to(copyElement, {
					//   duration: 1,
					//   rotationX: 90,  // Flip the element 180 degrees						
					// })

			});	

		
			$('.cp-scrolly').each(function() {
				const $triggerElt = $(this);
				const $pinElt = $triggerElt.find('.sticky-content');

				ScrollTrigger.create({
					trigger: $triggerElt,
					scrub: true,
					pin: $pinElt,
					// anticipatePin: true,
					start: "top 0",
					end: "bottom bottom",
					pinSpacing: false,
					onEnter: function(){
						gsap.to($triggerElt.find('.txt-sticky-left'), {color: '#26538A', duration:0.3})
					},
					onLeaveBack: function(){
						gsap.to($triggerElt.find('.txt-sticky-left'), {color: 'transparent', duration:0.3})
					}

					// animation: gsap.timeline().to($triggerElt.find('.txt-sticky-left'), {color: '#26538A', duration:1})
									// .to($triggerElt.find('.txt-sticky-left'), {color: '#26538A', duration:2})
				});
			});

			



			$('.st-line').each(function(){
				const elt = $(this);

				// for miscalcultation hide copy				
				gsap.set(elt, {opacity: 0});

				// tl_title.delay(delay_val); 
				ScrollTrigger.create({
					trigger: elt,
					scrub: true,
					anticipatePin: 1,
					// markers: true,
					start: "top 95%",
					once: true,
					onEnter: function(){
						// for miscalcultation show copy
						gsap.set(elt, {opacity: 1});

						let gsapChars = new SplitText(elt, { type: "lines,words,chars", linesClass: "lineChild" });

						const words = gsapChars.words;
						const chars = gsapChars.chars;


						var tl_title = gsap.timeline({paused: true});
						tl_title.from(words, {duration: 0.5, yPercent: 120, rotation: 5, ease: "power", stagger: 0.02})
							.add(function() {
								elt.addClass('played');
							});

						let delay_val = 0;
						if(elt[0].hasAttribute('data-delay')) {
							delay_val = $(this).attr('data-delay');
						}


						setTimeout(function(){
							tl_title.play();
						}, delay_val*1000)
					},
				});  

			});



		},


		// handleVideoSrc: function() {
		// 	var self = this; 
		// 	const vids = document.querySelectorAll("video[data-src]");
		// 	[...vids].forEach( 
		// 		function(vid) {
		// 			const src = vid.getAttribute('data-src');
		// 			vid.setAttribute('src', src);
		// 			// vid.setAttribute('autoplay', true);
		// 			self.playVideo(vid);
		// 		}
		// 	);
		// },
		// playVideo: function(vid) {
		// 	const self = this;
		// 	var playPromise = vid.play();
		// 	if (playPromise !== undefined) {
		// 		playPromise.then(function() {
		// 			// Automatic playback started!
		// 		}).catch(function(error) {
		// 			vid.muted = true;
		// 			vid.play();
		// 			// Automatic playback failed.
		// 			// Show a UI element to let the user manually start playback.
		// 			// vid.setAttribute('controls', true);

		// 			// const postersrc = vid.getAttribute('data-poster');
		// 			// vid.setAttribute('poster', postersrc);
		// 		});
		// 	}
		// },
		// pauseVideo: function(vid) {
		// 	vid.pause();
		// },

		

		/**
		 * inview animation
		 *
		 */
		inviewAnimation: function(){
			$("[class*='ivanim-']").each(function(){
				const $el = $(this);

				ScrollTrigger.create({
					trigger: $el, 
					id: "inview",
					start: "top bottom",
					onEnter: function(){
						if (!$el.hasClass('is-inview')) {
							$el.addClass('is-inview');
						}
					}
				});
			});

			// inview repeat
			$("[class*='ivanimr-']").each(function(){
				const $el = $(this);

				var start_val = "top bottom";
				if($el.hasClass('start-bottom')) {
					start_val = "bottom bottom";
				
					ScrollTrigger.create({
						trigger: $el, 
						start: start_val,
						onEnter: function(){
							if (!$el.hasClass('is-inview')) {
								$el.addClass('is-inview');
							}
						},
					});
					ScrollTrigger.create({
						trigger: $el, 
						start: 'top bottom',
						onLeaveBack: function(){ 
							if ($el.hasClass('is-inview')) {
								$el.removeClass('is-inview');
							}
						},
					});
				}
				else {
					ScrollTrigger.create({
						trigger: $el, 
						start: start_val,
						onEnter: function(){
							if (!$el.hasClass('is-inview')) {
								$el.addClass('is-inview');
							}
						},
						onLeave: function(){ 
							// if ($el.hasClass('is-inview')) {
							// 	$el.removeClass('is-inview');
							// }
						},
						onEnterBack: function(){ 
							// if (!$el.hasClass('is-inview')) {
							// 	$el.addClass('is-inview');
							// }
						},
						onLeaveBack: function(){ 
							if ($el.hasClass('is-inview')) {
								$el.removeClass('is-inview');
							}
						},
					});
				}

			});

			$('.js-anim-children--slidefade').each(function(){
				var elts = $(this).children();
				gsap.set(elts, {y: 30, opacity: 0});

				ScrollTrigger.batch(elts, {
					start: "top 90%",
					onEnter: function(batch){  gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true, duration: 1.2})},
				});
			})


		},
		

		/**
		 * loazyload Image
		 *
		 */
		loazyloadImage: function (section) {
			function loadImage($this){
				if($this.length > 0) {
					if(!$this.parent().hasClass("loaded")) {
						// $this.parent().find('source').attr('srcset', $this.parent().find('source').attr('data-srcset'));
						$this.attr("srcset", $this.attr("data-srcset"));
						$this.attr("src", $this.attr("data-src"));
						$this.on('load', function() { 
							$this.parent().addClass("loaded");
						})
						.on('error', function() { console.log("error loading image"); })
						// Remove it from the set of matching elements in order to avoid that the handler gets re-executed
					}
				}
			}

			$(section+" .lazyload").each(function() {
				var $this = $(this);
				// desktop batch load section images as inview buggy with the 3d panels
				if($(window).width() >= breakpointSite) {
					loadImage($this);
				}
				else {
					// on mobile we can load in view only
					// $(this).on("inview",  function() {
					loadImage($this);
					// })
				}
			});
		},

		/**
		 * Open links in new window
		 *
		 */
		newWindowLink: function () {

			// Select all elements containing the URL (e.g., anchor tags with href attribute)
			$('[href*="\\_"]').each(function() {
				// Get the current URL from the element
				var url = $(this).attr('href');

				// Replace the double underscore with a single underscore using regex
				var fixedUrl = url.replace(/\\_/g, "_");

				// Update the element's href attribute with the fixed URL
				$(this).attr('href', fixedUrl);
			});


			$('p a[href], .txt-source a[href]').not('.samewindow').each(function() {
				$(this).attr('target','_blank');
			});
		},


	};


	$(document).ready( function(){
		Site.init();
	})

})(jQuery);



// WEBPACK FOOTER //
// ./src/js/main.js